<template>
    <ProgressSpinner v-if="!relationship"/>
    <Container class="pt-6" v-if="relationship">
        <div class="bg-surface-0 dark:bg-surface-900 -mx-8 px-8 -mt-6 pt-6 -mb-4 pb-4">
            <PageHeading>
                {{ heading }}
            </PageHeading>
        </div>

        <div class="sticky top-0 bg-surface-0 dark:bg-surface-800 z-40 -mx-8 -px-8">
            <TabLayout :tabs="tabs" sticky/>
        </div>

        <router-view
                @on-save="$emit('on-save')"
                @on-delete="$emit('on-delete')"
                :relationship="relationship"
        ></router-view>
    </Container>
</template>

<script>
import PageHeading from "@/Components/PageHeading.vue";
import TabLayout from "@/Layouts/TabLayout.vue";
import Container from "@/Components/Container.vue";
import { mapStores } from "pinia";
import { useCompanyRelationshipsStore } from "@/stores/companyRelationships.js";

export default {
    name: "CompanyRelationshipAdminView",
    components: { Container, TabLayout, PageHeading },
    data() {
        return {
            relationship: undefined,
        };
    },
    emits: [
        'on-save',
        'on-delete',
    ],
    watch: {
        '$route.params.relationship': {
            async handler(newValue) {
                if (newValue) {
                    if (this.$route.params.relationship === 'NEW') {
                        this.relationship = {};
                    } else {
                        this.relationship = await this.companyRelationshipsStore.showCompanyRelationship(
                            this.$route.params.relationship,
                            { include: 'primaryCompany,secondaryCompany' }
                        );
                    }
                } else {
                    this.relationship = undefined;
                }
            },
            immediate: true,
        },
    },
    computed: {
        ...mapStores(useCompanyRelationshipsStore),
        heading() {
            if (this.$route.params.relationship === 'NEW') {
                return this.$route.params.relationship;
            }

            const primary = this.relationship?.primary_company?.name;
            const secondary = this.relationship?.secondary_company?.name;

            if (primary && secondary) {
                return `${primary} → ${secondary}`;
            }

            return `Relationship #${this.$route.params.relationship}`;
        },
        tabs() {
            return [
                {
                    label: this.$t('common.properties'),
                    current: this.$route.name === 'admin.companies.relationships.relationship',
                    to: { name: 'admin.companies.relationships.relationship', params: this.$route.params },
                },
            ];
        },
    },
};
</script>

<style scoped>
</style>
